import { render, staticRenderFns } from "./StampCouponList.vue?vue&type=template&id=50e220b8&scoped=true&"
import script from "./StampCouponList.vue?vue&type=script&lang=js&"
export * from "./StampCouponList.vue?vue&type=script&lang=js&"
import style0 from "./StampCouponList.vue?vue&type=style&index=0&id=50e220b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e220b8",
  null
  
)

export default component.exports